import styled from 'styled-components';
import ExpertBtn from './ExpertBtn';
function History() {
  return (
    <Wrap>
      <Introduce>
        <p>대표변호사 권오훈 인사말</p>
        <span>
          <Left>
            <span>
              찾아주셔서 감사합니다. 여러분의 훈훈한 이웃이 되어 고민을
              해결해드리겠습니다.
              <br />
              <strong>법률사무소 훈</strong>은 민사, 형사, 가사, 노동 등
              법률업무 전반에 걸쳐 풍부한 전문성과 경험을 가지고 있습니다.
              <br />
              소송, 자문, 절차대행을 포함한 모든 법률문제를 한 곳에서 처리할 수
              있는 원스톱시스템을 갖추고 있습니다.
              <br />
              <strong>법률사무소 훈</strong> 의 전문성을 믿고, 여러분의 답답하고
              힘들었던 사정을 상담하고 해결책을 찾으십시오. <br /> <br /> <br />
            </span>
          </Left>
          <br />
          모순이란 없습니다. <br />
          여러분에게, 모든 것을 뚫을 수 있는 창과 모든 것을 막을 수 있는 방패를
          모두 제공하겠습니다.
        </span>
      </Introduce>
      <ProfileWrap>
        <Text>
          <h3>PROFILE</h3>
          <p>서울대학교 법과대학 법학과 </p>
          <p>서울대학교 대학원 법학과 </p>
          <p>사법시험 합격 </p>
          <p>사법연수원 수료 </p>
          <p>법률사무소 훈 대표 변호사 </p>
          <p>노동법이론실무학회 정회원</p>
          <p>서울세검정초등학교 학교폭력대책자치위원회 전문위원</p>
          <p>중소기업청 비즈니스지원단 전문위원</p>
          <p>서울특별시 공익변호사</p>
          <p>청주지방법원 민사 및 가사 조정위원</p>
        </Text>
        <Image>
          <img src="/images/history_img1.jpg" />
        </Image>
      </ProfileWrap>
      <ExpertBtn />
    </Wrap>
  );
}
const Image = styled.div`
  width: 30%;
  height: 80vh;
  min-height: 550px;
  max-height: 800px;
  overflow: hidden;
  position: relative;
  box-shadow: 10px 5px 10px rgba(79, 79, 90, 0.3);
  img {
    width: 100%;
  }
  @media only screen and (max-width: 992px) {
    width: 50%;
    margin-top: 10px;
  }
  @media only screen and (max-width: 750px) {
    min-height: 400px;
    height: 400px;
    width: 60%;
  }
`;

const Text = styled.div`
  width: 30%;
  color: #000000;
  p {
    line-height: 32px;
  }
  h3 {
    color: ${props => props.theme.mainColor};
    font-size: 25px;
    position: relative;
    display: inline-block;
    margin-bottom: 25px;
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background: linear-gradient(to right, #fff, #f1bf78, #a07b53);
    }
  }
  @media only screen and (max-width: 992px) {
    width: 100%;
    text-align: center;
  }
`;
const ProfileWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  margin-top: 10px;
  @media only screen and (max-width: 992px) {
    flex-wrap: wrap;
  }
`;

const Introduce = styled.div`
  width: 60%;
  margin: 50px auto 100px auto;
  line-height: 26px;
  p {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #53504b;
  }
  span {
    font-size: 18px;
    line-height: 25px;
    color: #6b645a;
    text-align: left;
  }
  strong {
    color: #eeb356;
    font-weight: 700;
  }
  @media only screen and (max-width: 992px) {
    width: 85%;
    margin: 20px auto 50px auto;
    p {
      font-size: 16px;
      margin-bottom: 20px;
      color: #53504b;
    }
    span {
      font-size: 15px;
      line-height: 25px;
    }
  }
`;

const Wrap = styled.div`
  padding: 70px 0;
  width: 100%;
  text-align: center;
`;
const Left = styled.span`
  @media only screen and (max-width: 992px) {
    display: inline-block;
    text-align: left;
  }
`;
export default History;
